import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";

import { setTheme, useTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const { t } = useTranslation();
  const isDark = useTheme() === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? t("header.themeToLight") : t("header.themeToDark")}
      title={isDark ? t("header.themeToLight") : t("header.themeToDark")}
      aria-pressed={isDark}
      className="flex items-center justify-center h-8 w-8 shrink-0 rounded-full border border-line text-ink-muted hover:text-brand hover:border-brand transition-colors cursor-pointer"
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
